export default function OrderTime({ date }) {
  let dateStamp = new Date(date)

  return (
    <div className="tooltipped" data-tooltip={dateStamp}>
      {dateStamp.toLocaleDateString()}
    </div>
  )
}
